import React, { useReducer } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, isNotEmpty } from '../../lib/ep.js';

import { DynamicForm } from '../builder/DynamicForm.js';
import ButtonCollection from '../builder/ButtonCollection.js';
import PromoColsWrapper from './PromoColsWrapper.js';
import ActionButton from '../builder/ActionButton.js';
import SaveButton from '../builder/SaveButton.js';
import LeveledHTMLText from './helpers/LeveledHTMLText.js';
import ActionLink from '../builder/ActionLink.js';
import { localizeFields } from '../builder/DynamicFields.js';

const StageFormClient = ({ stage, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const is_builder = props?.is_builder ?? false;

	const [ state, dispatch ] = useReducer((state, action) => {
		switch (action.type) {
			case "CHANGE":
				return { ...state,user:action.user, valid:action.valid };

			case 'SUCCESS':
				return { ...state, state:'SUCCESS', result:action.result };
			
			case 'SHOW_ERRORS':
				return {...state,show_form_errors:true}

			default:
				return state;
		}
	}, {
		state:props?.section ?? 'FORM',
		valid:false,
		show_form_errors:false,
		user:{},
		result:false,
	});

	const change = (user, valid) => {
		dispatch({ type:'CHANGE', user, valid});
	};

	const submit = (e, cb) => {
		dispatch({ type:'SHOW_ERRORS' });
		if(!state.valid) {
			if(cb != undefined) cb();
			return;
		}

		props.submitQuiz(0, { form:state.user }, (result) => {
			if(stage.Stage.final_mode == 'redirect') {
				window.location.href = result.url;
				return;
			}

			if(cb != undefined) cb();

			dispatch({ type:'SUCCESS', result });
		});
	};

	const formFileUpload = (base64, field, cb) => {
		$.post(`/promotions/upload_form/${stage.Stage.promotion_id}`, { file:base64 }, (response) => {
			if(cb != undefined) cb(response);
		}, 'JSON');
	};

	const direct_description = (isNotEmpty(stage.Stage, 'direct_description')) ? stage.Stage.direct_description : i18n("Registering the participation...");

	if(state.state == 'SUCCESS') {
		const introduction_message = (isNotEmpty(stage.Stage, 'final_message')) ? stage.Stage.final_message : `<h1>Thank you!</h1><p>Now share this.</p>`;

		return (
			<div class="layout_conts">
				<div class="flex_cols">
					{(stage.Stage.final_image != "") && (
						<div class="flex_col col_1">
							<div class="main_media_flex">
								<img src={stage.Stage.full_final_image} alt="" style={{ maxWidth:'100%' }} />
							</div>
						</div>
					)}

					<div class="flex_col col_2">
						<article class="promo_desc gui_main_text_color_on_bg main_text_flex">
							<LeveledHTMLText
								_class={{ other:'promotion_title' }}
							>{introduction_message}</LeveledHTMLText>
						</article>

						<article class="promo_data template_module info_flexwrap gui_main_actions">
							<div class="template_submodule call_to_action_flex enter_flexwrap">
								<div class="enter flex_button gui_big_button register_flex">
									<ActionButton
										_href={(!is_builder) ? state.result.url : null}
									>Finalize</ActionButton>
								</div>
							</div>

							<div class="template_submodule entries_button_flex">
								<span class="view_galleries">
									<ActionLink
										_href={(!is_builder) ? `/promotions/participate/${stage.Stage.promotion_id}` : null}
									>Go back</ActionLink>
								</span>
							</div>
						</article>
					</div>
				</div>
			</div>
		)
	}
	const form = localizeFields(stage.Stage.form ?? [],props.locale);

	return (
		<div>
			<PromoColsWrapper
				main_image={stage.Stage?.direct_image && stage.Stage.full_direct_image} 
				main_video={stage.Stage.main_video} 
				main_description={direct_description} 
				extra_classes="gui_direct_participation"
			>
				<DynamicForm
					form={form}
					fileUpload={formFileUpload}
					showFormErrors={state.show_form_errors}
					field_config={props?.field_config ?? {}}
					onChange={change}
					public_form={true}
					model_classes="gui_form_register template_module gui_main_text_color_on_bg gui_form"
				/>
			</PromoColsWrapper>

			<ButtonCollection
				_class={{ other:'flex_button gui_big_button gui_not_in_top_big' }}
			>
				<SaveButton
					_fullclass=''
					onClick={submit}
					disabled={!state.valid && state.show_form_errors}
				>{(isNotEmpty(stage.Stage, 'main_button')) ? stage.Stage.main_button : "Continue"}</SaveButton>
			</ButtonCollection>
		</div>
	)
};

export default injectIntl(StageFormClient);